import { useContext } from 'react'
import { LocaleContext } from './LocaleContext'
import { TranslationKey, TranslationStrings, DEFAULT_LOCALE } from './index'

export function useTranslation() {
    const { locale } = useContext(LocaleContext)
    const defaultLocale = DEFAULT_LOCALE

    function t(key: TranslationKey): string {
        if (!TranslationStrings[locale]) {
            console.warn(`Translations for locale '${locale}' not found.`)
            return key
        }

        if (!TranslationStrings[locale][key]) {
            console.warn(`Translation '${key}' for locale '${locale}' not found.`)
            return key
        }
        return TranslationStrings[locale][key] || TranslationStrings[defaultLocale][key] || ''
    }

    function m(key: TranslationKey, replace: string, withThis: string): string {

        if (!TranslationStrings[locale]) {
            console.warn(`Translations for locale '${locale}' not found.`)
            return key
        }
        
        if (!TranslationStrings[locale][key]) {
            console.warn(`Translation '${key}' for locale '${locale}' not found.`)
            return key
        }

        const string = TranslationStrings[locale][key] || TranslationStrings[defaultLocale][key] || '' as string

        const changedString = string.replace(replace, withThis)
        return changedString;
    }

    return {
        t,
        m,
        keys: TranslationKey,
        locale
    }
}